import axios from "axios";
import * as Config from "../Utils/Config";
import { header } from "../Utils/ApiHeader";

// CREATE Plan
export const createPlanAPI = async (data, token) => {
  try {
    const response = await axios.post(
      `${Config.base_url}plans`,
      data,
      header(token)
    );
    return await response.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to create plan",
    };
  }
};

// GET All Plans
export const getAllPlansAPI = async (token, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await axios.get(
      `${Config.base_url}plans${queryParams ? `?${queryParams}` : ""}`,
      header(token)
    );
    return await response.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to fetch plans",
    };
  }
};

// GET Plan by ID
export const getPlanByIdAPI = async (id, token) => {
  try {
    const response = await axios.get(
      `${Config.base_url}plans/${id}`,
      header(token)
    );
    return await response.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to fetch plan",
    };
  }
};

// UPDATE Plan
export const updatePlanAPI = async (id, data, token) => {
  try {
    const response = await axios.post(
      `${Config.base_url}plans/update/${id}`,
      data,
      header(token)
    );
    return await response.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to update plan",
    };
  }
};

// DELETE Plan
export const deletePlanAPI = async (id, token) => {
  try {
    const response = await axios.post(
      `${Config.base_url}plans/delete/${id}`,
      header(token)
    );
    return await response?.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to delete plan",
    };
  }
};